import React from 'react'
import {Flex} from '/app/src/component'
import {connect} from 'react-redux'
import {FeedbackSelector} from '/app/src/model'
import RightPanel from '../RightPanel'

class FeedbackRightPanel extends React.Component {
    render() {
        const {faqId} = this.props
        if (!faqId) {
            return (
                <Flex h='100%' w='100%' center>
                    Välj en artikel i listan för att visa mer information.
                </Flex>
            )

        }
        return (
            <Flex w='100%'>
                <RightPanel faqId={faqId}/>
            </Flex>
        )
    }
}

function mapStateToProps(state) {
    const faqId = FeedbackSelector.getCurrentItem(state)
    return {faqId}
}

export default connect(mapStateToProps)(FeedbackRightPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/Feedback/index.js